<div class ="main">
    <div class ="header">
        <iframe src="https://3dwarehouse.sketchup.com/embed/u0ca71a2d-64da-45b5-91f2-260e71172b55" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" width="100%" height="100%" allowfullscreen></iframe>
        <!-- <audio autoplay loop src="./../../assets/Audios/beachbg.mp3"></audio> -->
    </div>
</div>